import Merch from './MerchandisingAttributes.container';
export default Merch;